<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="input-container" [class.disabled]="disabled">
  <label *ngIf="label" class="input-label">
    <hyperkit-typography variant="label1" color="inherit">
      {{ label }}
    </hyperkit-typography>
  </label>
  <div
    class="input-wrapper"
    [class.focused]="isFocused"
    [class.error]="hasError"
    [class.disabled]="disabled"
  >
    <hyperkit-typography
      variant="body1"
      color="primary"
      class="input-typography-wrapper"
    >
      <input
        #inputElement
        [type]="type"
        [value]="value"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (input)="onInput($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        class="input-field"
      />
    </hyperkit-typography>
    <hyperkit-icon
      *ngIf="rightIcon"
      [icon]="rightIcon"
      size="small"
      color="inherit"
      class="right-icon"
    ></hyperkit-icon>
    <hyperkit-icon
      *ngIf="showClear && value"
      icon="x"
      size="small"
      color="inherit"
      class="right-icon"
      (click)="onCancel()"
    ></hyperkit-icon>
  </div>

  <div *ngIf="hint" class="hint-container">
    <hyperkit-typography variant="body2" color="inherit">
      {{ hint }}
    </hyperkit-typography>
  </div>
  <div *ngIf="true" class="hint-container">
    <hyperkit-error [error]="errorMessage"></hyperkit-error>
  </div>
</div>